import { Users } from '@platform/client';
import { useEffect, useState } from 'react';
import hotjarPkg from 'react-hotjar';
// Special import boilerplate as react-hotjar is commonjs
const { hotjar } = hotjarPkg;

export const HOTJAR_ENABLED =
  // We don't have a dev environment for hotjar
  import.meta.env.VITE_ENVIRONMENT === 'production' &&
  !import.meta.env.SSR &&
  !!import.meta.env.VITE_HOTJAR_ID?.length &&
  import.meta.env.VITE_ANALYTICS_ENABLED === 'true' &&
  window?.CookieConsent?.statistics;

export const initHotjar = () => {
  if (!import.meta.env.VITE_HOTJAR_ID) {
    return;
  }

  hotjar.initialize({ id: import.meta.env.VITE_HOTJAR_ID, sv: 6 }); // Hotjar snippet version 6
};

/** Gets the current signed-in user and registers them with mixpanel analytics */
export const useIdentifyHotjarUser = () => {
  const userData = Users.useGetCurrentUser();

  const [isUserIdentified, setIsUserIdentified] = useState(false);

  useEffect(() => {
    if (!HOTJAR_ENABLED) {
      return;
    }

    if (!isUserIdentified && userData.isSuccess && userData.data) {
      hotjar.identify(userData.data.userId.toString(), {
        user_id: userData.data.userId.toString(),
        $role: userData.data.role,
        $email: userData.data.userName,
        $first_name: userData.data.firstName,
        $last_name: userData.data.lastName,
        // The Segment integration in the old app is also reporting
        // $created. Do we need this?
      });
      setIsUserIdentified(true);
    }
  }, [isUserIdentified, userData.data, userData.isSuccess]);
};
